import { useAuth } from "../../contexts/authContext"
import React, { lazy, Suspense, useEffect, useState } from 'react'
import styles from "./myAccount.module.css"
import api from './../../services/api'
import { FaPencilAlt } from 'react-icons/fa'
import { MdAccountBalance, MdClose, MdDone, MdOutlineAddCard, MdPersonAddAlt, MdStar, MdStorage, MdWarningAmber } from 'react-icons/md'
import { TbArrowsExchange, TbBarcode, TbCreditCard, TbExternalLink, TbFileInvoice, TbInfoCircle, TbReceiptTax, TbTrash, TbShieldCheck } from "react-icons/tb"
import { TfiReload } from "react-icons/tfi"
import Loading from '../layouts/Loading/index'
import { formatCurrency, maskDocument } from '../../utils/formatter'
import { getOptionByOptionList, getPropertyForItemInArrayById, listMethodsPayment, openLinkExternal } from '../../utils/utils'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import ModalNewRecharge from '../../components/Modal/ModalNewRecharge'
import ModalConfirm from "../../components/Modal/ModalConfirm"
import Button from '../../components/Form/Button'
import Select from '../../components/Form/Select'
import Modal from '../../components/Modal'
import Input from '../../components/Form/Input'
import FormGroup from '../../components/Form/FormGroup'
import FormGroupInline from '../../components/Form/FormGroupInline'
import { deleteCreditCardByAccount, getAllCreditCardsByAccount, setDefaultCreditCardByAccount } from '../../schemas/Transaction'
import { getPlanChangeConfirmation } from './planChangeConfirmation'

const ModalCreditCard = lazy(() => import('../../components/Modal/ModalCreditCard'))

const listTypes = [
    { id: "SUBSCRIPTION", value: "Mensalidade" },
    { id: "VOIP", value: "Créditos de ligações" },
    { id: "CHAT", value: "Créditos de IA" },
    { id: "PARTNER_PAYMENT", value: "Repasse mensal de parceiro" },
    { id: "ADDITIONAL_USERS", value: "Usuários adicionais" },
    { id: "ADDITIONAL_LEADS", value: "Base adicional de leads" },
    { id: "PLAN_CHANGE", value: "Troca de plano" },
]

const listStatus = [
    { id: "PENDING", value: "Aguardando Emissão" },
    { id: "OPENED", value: "Em Aberto" },
    { id: "APPROVED", value: "Aprovado" },
    { id: "CANCELED", value: "Cancelado" },
]

const optionsAutomaticRenovation = [
    { id: '1', value: "Ativada" },
    { id: '0', value: "Desativada" }
]

const contractOptions = [
    { id: "users", title: "Mais usuários", description: "Amplie o time com licenças adicionais.", icon: <MdPersonAddAlt /> },
    { id: "leads", title: "Mais base de leads", description: "Contrate capacidade extra para novos leads.", icon: <MdStorage /> },
    { id: "plan", title: "Trocar de plano", description: "Escolha um plano com mais recursos e limites.", icon: <TbArrowsExchange /> },
]

const paymentMethodOptions = [
    { id: "BANK_SLIP", value: "Boleto com PIX" },
    { id: "CREDIT_CARD", value: "Cartão de crédito" },
]

const initialCards = [{ id: "ADD_NEW", value: "Cadastrar novo cartão de crédito" }]
const createCouponRequestId = () => window.crypto?.randomUUID?.() || `coupon-${Date.now()}-${Math.random().toString(36).slice(2)}`

const MyAccount = () => {
    const { permissions } = useAuth()
    const readOnly = Boolean(permissions?.accessByAdminReadOnly)
    const [account, setAccount] = useState(null)
    const [transactions, setTransactions] = useState([])
    const [modalNewRecharge, setModalNewRecharge] = useState(false)
    const [dataPlan, setDataPlan] = useState({})
    const [editPlan, setEditPlan] = useState(false)
    const [modalChangePlan, setModalChangePlan] = useState(false)
    const [modalContract, setModalContract] = useState(false)
    const [titleChangePlan, setTitleChangePlan] = useState('')
    const [descriptionChangePlan, setDescriptionChangePlan] = useState('')
    const [textChangePlan, setTextChangePlan] = useState('')
    const [modalCreditCard, setModalCreditCard] = useState(false)
    const [cardToDelete, setCardToDelete] = useState(null)
    const [chargeDetails, setChargeDetails] = useState(null)
    const [modalRenewal, setModalRenewal] = useState(false)
    const [plans, setPlans] = useState([])
    const [modules, setModules] = useState([])
    const [creditCards, setCreditCards] = useState(initialCards)
    const [contractRequest, setContractRequest] = useState({ type: "users", quantity: 1, plan_id: "", method: "BANK_SLIP" })
    const [renewalRequest, setRenewalRequest] = useState({ method: "BANK_SLIP" })
    const [loading, setLoading] = useState(false)

    const { account_id } = useParams()

    useEffect(() => {
        if (account_id) {
            getDetailsByAccount()
            getTransactionsByAccount()
            getPlans()
            getModules()
            getCreditCards(true)
        }
    }, [account_id])

    useEffect(() => {
        setDataPlan(account?.plan || {})
    }, [account])

    useEffect(() => {
        if (contractRequest?.method === "CREDIT_CARD") {
            getCreditCards()
        }
    }, [contractRequest?.method])

    useEffect(() => {
        if (renewalRequest?.method === "CREDIT_CARD") {
            getCreditCards()
        }
    }, [renewalRequest?.method])

    const getDetailsByAccount = async () => {
        try {
            setLoading(true)
            const response = await api.get(`/accounts/${account_id}/details`)
            setAccount(response.data?.data || {})
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const getTransactionsByAccount = async () => {
        try {
            setLoading(true)
            const response = await api.get(`/accounts/${account_id}/transactions/details`)
            setTransactions(response.data?.data || [])
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const handleCreateNewRecharge = async (transaction) => {
        try {
            setLoading(true)
            const response = await api.post(`/accounts/${account_id}/transactions/recharges`, transaction)
            const newTransaction = response.data?.data
            setTransactions(previousValue => {
                const newValue = [...previousValue]
                const transactionExists = newValue.map(transaction => transaction._id).includes(newTransaction._id)
                if (!transactionExists) {
                    newValue.unshift(newTransaction)
                }
                return newValue
            })
            if (newTransaction?.link_charge) {
                openLinkExternal(newTransaction.link_charge)
            }
            closeModalNewRecharge()
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const openModalNewRecharge = () => {
        setModalNewRecharge(true)
    }

    const closeModalNewRecharge = () => {
        setModalNewRecharge(false)
    }

    const handleChangePlan = (name, value) => {
        setDataPlan(previousValue => {
            return { ...previousValue, [name]: value }
        })
    }

    const handleCancelEditPlan = () => {
        setDataPlan(account?.plan || {})
        setEditPlan(false)
    }

    const handleConfirmChangePlan = () => {
        const confirmation = getPlanChangeConfirmation(account?.plan, dataPlan)
        if (confirmation) {
            setTitleChangePlan(confirmation.title)
            setDescriptionChangePlan(confirmation.description)
            setTextChangePlan(confirmation.text)
            setModalChangePlan(true)
        } else {
            handleCancelEditPlan()
        }
    }

    const handleUpdatePlan = () => {
        setLoading(true)
        api.patch(`/accounts/${account_id}/plan`, dataPlan).then(response => {
            setAccount(previousValue => {
                return { ...previousValue, plan: { ...previousValue.plan, ...dataPlan } }
            })
            handleCloseModalPlan()
            handleCancelEditPlan()
            toast.success(response?.data?.message)
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const handleCloseModalPlan = () => {
        setModalChangePlan(false)
    }

    const getPlans = async () => {
        try {
            const response = await api.get("/plans")
            const listPlans = (response.data?.data || []).filter(plan => plan?.show_self_service && !plan?.payment_by_partner)
            setPlans(listPlans)
            setContractRequest(previousValue => ({ ...previousValue, plan_id: previousValue.plan_id || listPlans?.[0]?._id || "" }))
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const getModules = async () => {
        try {
            const response = await api.get("/modules")
            setModules(response.data?.data || [])
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const getCreditCards = async (force = false) => {
        if (!force && creditCards?.length > 1) {
            return
        }
        const allCards = await getAllCreditCardsByAccount()
        const formattedCards = allCards?.map(card => ({ id: card?._id, value: card?.name, ...card })) || []
        setCreditCards([...initialCards, ...formattedCards])
        setContractRequest(previousValue => {
            if (previousValue?.method !== "CREDIT_CARD" || previousValue?.card_id || !formattedCards.length) {
                return previousValue
            }
            const defaultCard = formattedCards.find(card => card.is_default) || formattedCards[0]
            return { ...previousValue, card_id: defaultCard.id }
        })
    }

    const refreshCreditCards = async () => {
        await getCreditCards(true)
    }

    const handleAddCreditCardSuccess = async () => {
        await refreshCreditCards()
        setModalCreditCard(false)
    }

    const handleSetDefaultCreditCard = async (cardId) => {
        try {
            setLoading(true)
            const response = await setDefaultCreditCardByAccount(cardId)
            await refreshCreditCards()
            setContractRequest(previousValue => previousValue?.method === "CREDIT_CARD" ? { ...previousValue, card_id: cardId } : previousValue)
            toast.success(response?.message)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const handleDeleteCreditCard = async () => {
        if (!cardToDelete?.id) {
            return
        }
        try {
            setLoading(true)
            const response = await deleteCreditCardByAccount(cardToDelete.id)
            await refreshCreditCards()
            setContractRequest(previousValue => previousValue?.card_id === cardToDelete.id ? { ...previousValue, card_id: undefined } : previousValue)
            setCardToDelete(null)
            toast.success(response?.message)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const openModalContract = (type = "users") => {
        const selectedPlanId = plans?.find(plan => plan.name !== account?.plan?.name)?._id || plans?.[0]?._id || ""
        const method = account?.plan?.default_method === "CREDIT_CARD" ? "CREDIT_CARD" : "BANK_SLIP"
        const savedCards = creditCards.filter(card => card.id !== "ADD_NEW")
        const defaultCard = savedCards.find(card => card.is_default) || savedCards[0]
        setContractRequest({ type, quantity: 1, plan_id: selectedPlanId, method, card_id: method === "CREDIT_CARD" ? defaultCard?.id : undefined, coupon_code: "", coupon_request_id: createCouponRequestId(), coupon_preview: null })
        setModalContract(true)
    }

    const closeModalContract = () => {
        setModalContract(false)
    }

    const openModalRenewal = () => {
        const method = account?.plan?.default_method === "CREDIT_CARD" ? "CREDIT_CARD" : "BANK_SLIP"
        const savedCards = creditCards.filter(card => card.id !== "ADD_NEW")
        const defaultCard = savedCards.find(card => card.is_default) || savedCards[0]
        setRenewalRequest({ method, card_id: method === "CREDIT_CARD" ? defaultCard?.id : undefined, coupon_code: "", coupon_request_id: createCouponRequestId(), coupon_preview: null })
        setModalRenewal(true)
    }

    const closeModalRenewal = () => {
        setModalRenewal(false)
    }

    const handleChangeContract = (name, value) => {
        if (name === "quantity") {
            const quantity = Math.max(1, Math.floor(Number(value) || 1))
            setContractRequest(previousValue => ({ ...previousValue, [name]: quantity, coupon_preview: null, coupon_request_id: createCouponRequestId() }))
            return
        }
        setContractRequest(previousValue => ({ ...previousValue, [name]: value, coupon_preview: name === "card_id" ? previousValue.coupon_preview : null, coupon_request_id: name === "card_id" ? previousValue.coupon_request_id : createCouponRequestId() }))
    }

    const handleChangeRenewal = (name, value) => {
        if (name === "method" && value === "CREDIT_CARD") {
            const savedCards = creditCards.filter(card => card.id !== "ADD_NEW")
            const defaultCard = savedCards.find(card => card.is_default) || savedCards[0]
            setRenewalRequest(previousValue => ({ ...previousValue, method: value, card_id: previousValue?.card_id || defaultCard?.id, coupon_preview: null, coupon_request_id: createCouponRequestId() }))
            return
        }
        setRenewalRequest(previousValue => ({ ...previousValue, [name]: value, coupon_preview: name === "card_id" ? previousValue.coupon_preview : null, coupon_request_id: name === "card_id" ? previousValue.coupon_request_id : createCouponRequestId() }))
    }

    const validateCoupon = async (scope) => {
        const request = scope === "contract" ? contractRequest : renewalRequest
        if (!request?.coupon_code?.trim()) return
        try {
            setLoading(true)
            const amount = scope === "contract" ? Number(getContractEstimate().toFixed(2)) : undefined
            const components = scope === "contract" ? {
                basePlan: request.type === "plan" ? amount : 0,
                additionalUsers: request.type === "users" ? amount : 0,
                additionalLeads: request.type === "leads" ? amount : 0,
                additionalCharges: 0,
            } : undefined
            const response = await api.post(`/accounts/${account_id}/coupons/validate`, {
                code: request.coupon_code,
                plan_id: scope === "contract" && request.type === "plan" ? request.plan_id : currentPlan?._id,
                payment_method: request.method,
                pricing_override: amount !== undefined ? { amount, components } : undefined,
            })
            const update = previous => ({ ...previous, coupon_code: request.coupon_code.trim().toUpperCase(), coupon_preview: response.data.data })
            scope === "contract" ? setContractRequest(update) : setRenewalRequest(update)
            toast.success("Cupom validado com sucesso.")
        } catch (err) {
            const update = previous => ({ ...previous, coupon_preview: null })
            scope === "contract" ? setContractRequest(update) : setRenewalRequest(update)
            toast.error(err?.response?.data?.message || "Não foi possível validar o cupom.")
        } finally {
            setLoading(false)
        }
    }

    const getCurrentPlan = () => {
        return plans?.find(plan => plan.name === account?.plan?.name) || {}
    }

    const getSelectedContractPlan = () => {
        return plans?.find(plan => plan._id === contractRequest?.plan_id) || {}
    }

    const getContractEstimate = () => {
        const quantity = Number(contractRequest?.quantity) || 0
        const currentPlan = getCurrentPlan()
        const selectedPlan = getSelectedContractPlan()
        const expiresIn = account?.plan?.expires_in_raw ? new Date(account.plan.expires_in_raw) : null
        const daysRemaining = expiresIn && expiresIn > new Date() ? Math.max(1, Math.ceil((expiresIn - new Date()) / (1000 * 60 * 60 * 24))) : 30
        if (contractRequest?.type === "users") {
            return quantity * ((Number(currentPlan?.additional_cost?.users) || 0) / 30) * daysRemaining
        }
        if (contractRequest?.type === "leads") {
            return quantity * ((Number(currentPlan?.additional_cost?.leads) || 0) / 30) * daysRemaining
        }
        if (contractRequest?.type === "plan") {
            return Number(selectedPlan?.value) || 0
        }
        return 0
    }

    const getModuleNameById = (moduleId) => {
        const id = moduleId?.module_id || moduleId
        const module = modules.find(item => item._id?.toString() === id?.toString())
        return module?.name || module?.value || ""
    }

    const getPlanModuleNames = (plan) => {
        return (plan?.modules || [])
            .map(getModuleNameById)
            .filter(Boolean)
            .sort()
    }

    const getCurrentModuleNames = () => {
        return (account?.modules || [])
            .filter(module => module?.is_active)
            .map(module => module.name)
            .filter(Boolean)
            .sort()
    }

    const getModuleDiff = () => {
        const currentModules = getCurrentModuleNames()
        const selectedModules = getPlanModuleNames(selectedContractPlan)
        const allModules = [...new Set([...currentModules, ...selectedModules])].sort().map(module => ({
            name: module,
            status: selectedModules.includes(module) && !currentModules.includes(module) ? "gain" : (!selectedModules.includes(module) && currentModules.includes(module) ? "loss" : "keep")
        }))
        return {
            currentModules,
            selectedModules,
            allModules,
            gained: selectedModules.filter(module => !currentModules.includes(module)),
            lost: currentModules.filter(module => !selectedModules.includes(module)),
        }
    }

    const getTransactionStatusStyle = (status) => {
        if (status === "APPROVED") return styles.approved
        if (status === "PENDING") return styles.pending
        return styles.rejected
    }

    const getChargeAction = (method) => {
        if (method === "CREDIT_CARD") {
            return { label: "Pagamento", title: "Abrir link de pagamento", icon: <TbCreditCard /> }
        }
        return { label: "Boleto", title: "Abrir boleto", icon: <TbBarcode /> }
    }

    const handleSubmitContractRequest = (e) => {
        e.preventDefault()
        setLoading(true)
        api.post(`/accounts/${account_id}/plan/self-service-upgrade`, contractRequest).then(response => {
            const newTransaction = response.data?.data
            if (newTransaction) {
                setTransactions(previousValue => [newTransaction, ...previousValue])
            }
            if (newTransaction?.link_charge || newTransaction?.payment_link) {
                openLinkExternal(newTransaction.link_charge || newTransaction.payment_link)
            }
            if (newTransaction?.status === "APPROVED") {
                getDetailsByAccount()
            }
            toast.success(response?.data?.message)
            closeModalContract()
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const handleSubmitRenewal = (e) => {
        e.preventDefault()
        setLoading(true)
        api.post(`/accounts/${account_id}/plan/renew`, renewalRequest).then(response => {
            const newTransaction = response.data?.data
            if (newTransaction) {
                setTransactions(previousValue => {
                    const filteredTransactions = previousValue.filter(transaction => transaction?.transaction_id !== newTransaction?.transaction_id && transaction?._id !== newTransaction?._id)
                    return [newTransaction, ...filteredTransactions]
                })
            }
            if (newTransaction?.link_charge || newTransaction?.payment_link) {
                openLinkExternal(newTransaction.link_charge || newTransaction.payment_link)
            }
            if (newTransaction?.status === "APPROVED") {
                getDetailsByAccount()
            }
            toast.success(response?.data?.message)
            closeModalRenewal()
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const openChargeDetails = async (transaction) => {
        try {
            setLoading(true)
            const response = await api.get(`/accounts/${account_id}/transactions/${transaction.transaction_id}/charges/${transaction.charge_id || transaction._id}/details`)
            setChargeDetails(response?.data?.data || null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const closeChargeDetails = () => {
        setChargeDetails(null)
    }

    const renderDetailItem = (label, value) => {
        if (value === undefined || value === null || value === "") {
            return null
        }
        return (
            <div className={styles.detailItem}>
                <span>{label}</span>
                <strong>{value}</strong>
            </div>
        )
    }

    const modulesActive = account?.modules?.filter(module => module.is_active)?.length || 0
    const modulesTotal = account?.modules?.length || 0
    const lastTransaction = transactions?.[0]
    const contractType = contractOptions.find(option => option.id === contractRequest?.type)
    const currentPlan = getCurrentPlan()
    const selectedContractPlan = getSelectedContractPlan()
    const contractEstimate = getContractEstimate()
    const moduleDiff = getModuleDiff()
    const chatCredits = Number(account?.credits?.chat || 0)
    const voipCredits = Number(account?.credits?.voip || 0)
    const monthlyChatCredits = Number(account?.credits?.chat_monthly || 0)
    const savedCreditCards = creditCards.filter(card => card.id !== "ADD_NEW")
    const expiresIn = account?.plan?.expires_in_raw ? new Date(account.plan.expires_in_raw) : null
    const licenseDaysRemaining = expiresIn ? Math.ceil((expiresIn - new Date()) / (1000 * 60 * 60 * 24)) : undefined
    const isLicenseExpired = licenseDaysRemaining !== undefined && licenseDaysRemaining < 0
    const hasLicenseExpiration = licenseDaysRemaining !== undefined
    const isTrial = Boolean(account?.plan?.is_trial)
    const availableContractOptions = isTrial ? contractOptions.filter(option => option.id === "plan") : contractOptions
    const shouldShowRenewalPanel = !!account && !isTrial && !account?.plan?.payment_by_partner && (!hasLicenseExpiration || isLicenseExpired || licenseDaysRemaining <= 7 || Number(account?.plan?.automatic_renovation) === 0)
    const renewalStatusText = licenseDaysRemaining === undefined
        ? "Assinatura ainda sem ciclo ativo"
        : (licenseDaysRemaining < 0 ? `Expirou há ${Math.abs(licenseDaysRemaining)} dia(s)` : (licenseDaysRemaining === 0 ? "Expira hoje" : `Expira em ${licenseDaysRemaining} dia(s)`))

    return (
        <>
            <div className={styles.content} >
                <div className={styles.page}>
                    <div className={styles.hero}>
                        <div className={styles.heroIcon}>
                            <MdAccountBalance />
                        </div>
                        <div className={styles.heroText}>
                            <span className={styles.eyebrow}>Conta</span>
                            <h1>Minha Conta</h1>
                            <p>{account?.company?.fantasy_name || account?.company?.business_name || "Dados financeiros e contratuais da conta"}</p>
                        </div>
                        <Button disabled={readOnly} variant='primary' fullWidth={false} onClick={() => openModalNewRecharge()}>Nova Recarga</Button>
                    </div>

                    {isTrial &&
                        <section className={`${styles.renewalPanel} ${isLicenseExpired ? styles.expired : ""}`}>
                            <div className={styles.renewalIcon}>
                                {isLicenseExpired ? <MdWarningAmber /> : <TbShieldCheck />}
                            </div>
                            <div className={styles.renewalText}>
                                <span className={styles.eyebrow}>{isLicenseExpired ? "Teste encerrado" : "Teste grátis Advanced"}</span>
                                <h2>{isLicenseExpired ? "Escolha um plano para continuar usando o Oktto" : "Aproveite o Advanced e contrate quando estiver pronto"}</h2>
                                <p>{isLicenseExpired ? "Seus dados continuam preservados. Selecione um plano, aplique seu cupom e conclua o pagamento para reativar a conta." : `${Math.max(0, licenseDaysRemaining ?? account?.plan?.trial_days ?? 15)} dia(s) restante(s). Todos os recursos do Advanced estão liberados para até 2 usuários, com 1 caixa de entrada e equipes ilimitadas.`}</p>
                            </div>
                            <div className={styles.renewalActions}>
                                <Button disabled={readOnly} variant='primary' fullWidth={false} onClick={() => openModalContract("plan")}>Contratar um plano</Button>
                            </div>
                        </section>
                    }

                    {shouldShowRenewalPanel &&
                        <section className={`${styles.renewalPanel} ${isLicenseExpired || !hasLicenseExpiration ? styles.expired : ""}`}>
                            <div className={styles.renewalIcon}>
                                {isLicenseExpired || !hasLicenseExpiration ? <MdWarningAmber /> : <TbShieldCheck />}
                            </div>
                            <div className={styles.renewalText}>
                                <span className={styles.eyebrow}>{isLicenseExpired || !hasLicenseExpiration ? "Licença bloqueada" : "Renovação"}</span>
                                <h2>{isLicenseExpired || !hasLicenseExpiration ? "Renove a assinatura para ativar a conta" : "Mantenha a assinatura em dia"}</h2>
                                <p>{renewalStatusText}. {!hasLicenseExpiration ? "Gere a primeira mensalidade para iniciar o ciclo de uso." : (Number(account?.plan?.automatic_renovation) === 0 ? "A renovação automática está desativada, então a mensalidade pode não ser criada sozinha." : "Você pode pagar a mensalidade aberta ou gerar uma nova renovação quando necessário.")}</p>
                            </div>
                            <div className={styles.renewalActions}>
                                <Button disabled={readOnly} variant='primary' fullWidth={false} onClick={openModalRenewal}>Renovar assinatura</Button>
                            </div>
                        </section>
                    }

                    <div className={styles.summaryGrid}>
                        <div className={styles.summaryCard}>
                            <span>Licença</span>
                            <strong>{isTrial ? "Advanced (teste)" : (account?.plan?.name || "-")}</strong>
                            <small>Expira em {account?.plan?.expires_in || "-"}</small>
                        </div>
                        <div className={styles.summaryCard}>
                            <span>Valor do plano</span>
                            <strong>{isTrial ? "Grátis" : (account?.plan?.value || "-")}</strong>
                            <small>{isTrial ? "Nenhuma cobrança automática" : (getOptionByOptionList(account?.plan?.automatic_renovation?.toString() || '', optionsAutomaticRenovation) || '-')}</small>
                        </div>
                        <div className={styles.summaryCard}>
                            <span>Módulos ativos</span>
                            <strong>{modulesActive}/{modulesTotal}</strong>
                            <small>Recursos contratados</small>
                        </div>
                        <div className={styles.summaryCard}>
                            <span>Créditos de IA</span>
                            <strong>{chatCredits.toLocaleString("pt-BR", { maximumFractionDigits: 1 })}</strong>
                            <small>{monthlyChatCredits > 0 ? `${monthlyChatCredits.toLocaleString("pt-BR")} créditos/mês no plano` : "Usados por agentes e transcrições"}</small>
                        </div>
                        <div className={styles.summaryCard}>
                            <span>Créditos de ligações</span>
                            <strong>{formatCurrency(voipCredits)}</strong>
                            <small>Saldo para chamadas VoIP</small>
                        </div>
                        <div className={styles.summaryCard}>
                            <span>Última fatura</span>
                            <strong>{lastTransaction?.value || "-"}</strong>
                            <small>{getPropertyForItemInArrayById(lastTransaction?.status, listStatus, "id", "value") || "Sem faturas"}</small>
                        </div>
                    </div>

                    <div className={styles.layout}>
                        <div className={styles.mainColumn}>
                            {!account?.plan?.payment_by_partner && !isTrial &&
                                <section className={styles.panel}>
                                    <div className={styles.sectionHeader}>
                                        <div>
                                            <span className={styles.eyebrow}>Upgrade</span>
                                            <h2>Contratar mais capacidade</h2>
                                        </div>
                                    </div>
                                    <div className={styles.contractGrid}>
                                        {availableContractOptions.map(option => (
                                            <button disabled={readOnly} className={styles.contractOption} key={option.id} type="button" onClick={() => openModalContract(option.id)}>
                                                <div className={styles.contractIcon}>{option.icon}</div>
                                                <div>
                                                    <span>{option.title}</span>
                                                    <small>{option.description}</small>
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </section>
                            }

                            <section className={styles.panel}>
                                <div className={styles.sectionHeader}>
                                    <div>
                                        <span className={styles.eyebrow}>Empresa</span>
                                        <h2>Dados da conta</h2>
                                    </div>
                                </div>
                                <div className={styles.infoGrid}>
                                    <div className={styles.infoItem}>
                                        <span>Documento</span>
                                        <strong>{account?.company?.is_foreigner ? account?.company?.document : maskDocument(account?.company?.document) || "-"}</strong>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span>Razão social</span>
                                        <strong>{account?.company?.business_name || "-"}</strong>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span>Nome fantasia</span>
                                        <strong>{account?.company?.fantasy_name || "-"}</strong>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span>E-mail do responsável</span>
                                        <strong>{account?.email_owner || "-"}</strong>
                                    </div>
                                </div>
                            </section>

                            <section className={styles.panel}>
                                <div className={styles.sectionHeader}>
                                    <div>
                                        <span className={styles.eyebrow}>Financeiro</span>
                                        <h2>Histórico de faturas</h2>
                                    </div>
                                    <Button disabled={readOnly} variant='primary' fullWidth={false} onClick={() => openModalNewRecharge()}>Nova Recarga</Button>
                                </div>
                                <div className={styles.transactions}>
                                    {transactions.length > 0 &&
                                        <div className={styles.invoiceHeader}>
                                            <span></span>
                                            <span>Fatura</span>
                                            <span>Status</span>
                                            <span>Valor</span>
                                            <span>Documentos</span>
                                        </div>
                                    }
                                    {transactions.length > 0 && transactions.map((transaction, index) => {
                                        const chargeAction = getChargeAction(transaction?.method)
                                        return (
                                            <div className={styles.groupTransaction} key={transaction?._id || index}>
                                                <div className={styles.invoiceIcon}>
                                                    <TbReceiptTax />
                                                </div>
                                                <div className={styles.invoiceType}>
                                                    <span>{getPropertyForItemInArrayById(transaction?.type, listTypes, "id", "value") || '-'}</span>
                                                    <small>Vencimento: {transaction?.due_date || '-'}</small>
                                                </div>
                                                <div className={`${styles.statusBadge} ${getTransactionStatusStyle(transaction?.status)}`}>
                                                    {getPropertyForItemInArrayById(transaction?.status, listStatus, "id", "value") || '-'}
                                                </div>
                                                <div className={styles.invoiceValue}>
                                                    <span>{transaction?.value || '-'}</span>
                                                    <small>{getPropertyForItemInArrayById(transaction?.method, listMethodsPayment, "id", "value") || '-'}</small>
                                                    {transaction?.payment_summary && <small>{transaction.payment_summary}</small>}
                                                </div>
                                                <div className={styles.right}>
                                                    <button className={`${styles.invoiceAction} ${styles.invoiceDocumentAction}`} type="button" onClick={() => openChargeDetails(transaction)} title="Ver detalhes">
                                                        <TbInfoCircle />
                                                    </button>
                                                    {transaction?.link_charge &&
                                                        <a className={`${styles.invoiceAction} ${styles.invoiceChargeAction}`} href={transaction.link_charge} target="_blank" rel="noreferrer" title={chargeAction.title}>
                                                            {chargeAction.icon}
                                                        </a>
                                                    }
                                                    {transaction?.link_invoice &&
                                                        <a className={`${styles.invoiceAction} ${styles.invoiceDocumentAction}`} href={transaction.link_invoice} target="_blank" rel="noreferrer" title="Abrir nota fiscal">
                                                            <TbFileInvoice />
                                                        </a>
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {transactions.length === 0 && <div className={styles.emptyState}>Nenhuma fatura encontrada.</div>}
                                </div>
                            </section>
                        </div>

                        <aside className={styles.sideColumn}>
                            <section className={styles.panel}>
                                <div className={styles.sectionHeader}>
                                    <div>
                                        <span className={styles.eyebrow}>Plano</span>
                                        <h2>Assinatura</h2>
                                    </div>
                                    {!account?.plan?.payment_by_partner && !isTrial && !editPlan &&
                                        <Button disabled={readOnly} variant='secondary' fullWidth={false} onClick={() => setEditPlan(true)}><FaPencilAlt /></Button>
                                    }
                                </div>
                                <div className={styles.planStack}>
                                    <div className={styles.infoItem}>
                                        <span>Licença</span>
                                        <strong>{isTrial ? "Advanced (teste grátis)" : (account?.plan?.name || "-")}</strong>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span>Expira em</span>
                                        <strong>{account?.plan?.expires_in || "-"}</strong>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span>Valor</span>
                                        <strong>{isTrial ? "Grátis durante o teste" : (account?.plan?.value || "-")}</strong>
                                    </div>
                                    <div className={styles.infoItem}>
                                        <span>Renovação automática</span>
                                        {isTrial ? <strong>Não haverá cobrança automática</strong> : editPlan ?
                                            <Select multiple={false} name="Selecione uma opção..." placeholder="Buscar..." options={optionsAutomaticRenovation || []} onChange={(value) => handleChangePlan("automatic_renovation", value)} selected={dataPlan?.automatic_renovation?.toString() || ''} />
                                            :
                                            <strong>{getOptionByOptionList(account?.plan?.automatic_renovation?.toString() || '', optionsAutomaticRenovation) || '-'}</strong>
                                        }
                                    </div>
                                    {!account?.plan?.payment_by_partner &&
                                        <div className={styles.infoItem}>
                                            <span>Pagamento padrão</span>
                                            {editPlan ?
                                                <Select multiple={false} name="Forma de pagamento" placeholder="Buscar..." options={paymentMethodOptions} onChange={(value) => handleChangePlan("default_method", value)} selected={dataPlan?.default_method || 'BANK_SLIP'} />
                                                :
                                                <strong>{getOptionByOptionList(account?.plan?.default_method || 'BANK_SLIP', paymentMethodOptions) || '-'}</strong>
                                            }
                                        </div>
                                    }
                                    {editPlan &&
                                        <div className={styles.editActions}>
                                            <Button variant='primary' onClick={handleConfirmChangePlan}>Salvar</Button>
                                            <Button variant='secondary' onClick={handleCancelEditPlan}>Cancelar</Button>
                                        </div>
                                    }
                                </div>
                            </section>

                            {!account?.plan?.payment_by_partner &&
                                <section className={styles.panel}>
                                    <div className={styles.sectionHeader}>
                                        <div>
                                            <span className={styles.eyebrow}>Pagamentos</span>
                                            <h2>Métodos de pagamento</h2>
                                        </div>
                                        <Button disabled={readOnly} variant='primary' fullWidth={false} onClick={() => setModalCreditCard(true)}><MdOutlineAddCard />Adicionar</Button>
                                    </div>
                                    <div className={styles.paymentCards}>
                                        {savedCreditCards.map(card => (
                                            <div className={styles.paymentCard} key={card.id}>
                                                <div className={styles.cardBrandIcon}>
                                                    <TbCreditCard />
                                                </div>
                                                <div className={styles.paymentCardInfo}>
                                                    <strong>{card.display_name || card.value}</strong>
                                                    <span>Final {card.last4 || "----"} • Expira em {card.exp_month || "--"}/{card.exp_year || "----"}</span>
                                                </div>
                                                {card.is_default ?
                                                    <div className={styles.defaultBadge}><MdStar />Padrão</div>
                                                    :
                                                    <button disabled={readOnly} className={styles.iconAction} type="button" title="Definir como padrão" onClick={() => handleSetDefaultCreditCard(card.id)}>
                                                        <MdStar />
                                                    </button>
                                                }
                                                <button disabled={readOnly} className={`${styles.iconAction} ${styles.dangerAction}`} type="button" title="Excluir cartão" onClick={() => setCardToDelete(card)}>
                                                    <TbTrash />
                                                </button>
                                            </div>
                                        ))}
                                        {!savedCreditCards.length &&
                                            <div className={styles.emptyState}>Nenhum cartão cadastrado.</div>
                                        }
                                    </div>
                                </section>
                            }

                            <section className={styles.panel}>
                                <div className={styles.sectionHeader}>
                                    <div>
                                        <span className={styles.eyebrow}>Uso</span>
                                        <h2>Consumo</h2>
                                    </div>
                                </div>
                                <div className={styles.usageGrid}>
                                    <div>
                                        <span>Usuários</span>
                                        <strong>{account?.plan?.usage_users || "-"}</strong>
                                    </div>
                                    <div>
                                        <span>Leads</span>
                                        <strong>{account?.plan?.usage_leads || "-"}</strong>
                                    </div>
                                    <div>
                                        <span>Armazenamento</span>
                                        <strong>{account?.plan?.usage_storage || "-"}</strong>
                                    </div>
                                </div>
                            </section>

                            <section className={styles.panel}>
                                <div className={styles.sectionHeader}>
                                    <div>
                                        <span className={styles.eyebrow}>Recursos</span>
                                        <h2>Módulos contratados</h2>
                                    </div>
                                </div>
                                <div className={styles.modulesGrid}>
                                    {account?.modules?.map((module, index) => (
                                        <div className={`${styles.modulePill} ${module.is_active ? styles.active : ''}`} key={index}>
                                            <span>{module.name}</span>
                                            <strong>{module.is_active ? "Ativo" : "Inativo"}</strong>
                                        </div>
                                    ))}
                                    {!account?.modules?.length && <div className={styles.emptyState}>Nenhum módulo encontrado.</div>}
                                </div>
                            </section>
                        </aside>
                    </div>
                    {modalNewRecharge &&
                        <ModalNewRecharge
                            onSubmit={handleCreateNewRecharge}
                            closeModal={closeModalNewRecharge}
                        />
                    }
                    {modalContract &&
                        <Modal
                            icon={contractType?.icon}
                            title={isTrial ? "Escolha seu plano" : (contractType?.title || "Contratar upgrade")}
                            description={isTrial ? "Contrate diretamente pelo Oktto e continue usando sua conta e seus dados" : "Revise a contratação e siga para o pagamento"}
                            closeModal={closeModalContract}
                        >
                            <form onSubmit={handleSubmitContractRequest} className={styles.contractForm}>
                                {!isTrial && <div className={styles.contractChoices}>
                                    {availableContractOptions.map(option => (
                                        <button
                                            className={`${styles.contractChoice} ${contractRequest?.type === option.id ? styles.active : ""}`}
                                            key={option.id}
                                            type="button"
                                            onClick={() => handleChangeContract("type", option.id)}
                                        >
                                            {option.icon}
                                            <span>{option.title}</span>
                                        </button>
                                    ))}
                                </div>}
                                {contractRequest?.type === "plan" ?
                                    <FormGroup labelText="Plano desejado">
                                        <Select
                                            multiple={false}
                                            name="Selecione um plano"
                                            placeholder="Buscar plano"
                                            options={plans?.map(plan => ({ id: plan._id, value: `${plan.name} - ${formatCurrency(plan.value)}` })) || []}
                                            selected={contractRequest?.plan_id || ""}
                                            onChange={(value) => handleChangeContract("plan_id", value)}
                                        />
                                    </FormGroup>
                                    :
                                    <FormGroup labelText={contractRequest?.type === "users" ? "Usuários adicionais" : "Pacotes de 1000 leads"}>
                                        <Input
                                            type="number"
                                            placeholder={contractRequest?.type === "users" ? "Quantidade" : "Quantidade de pacotes"}
                                            value={contractRequest?.quantity ?? ""}
                                            min="1"
                                            step="1"
                                            onChange={(e) => handleChangeContract("quantity", e.target.value)}
                                        />
                                    </FormGroup>
                                }
                                <FormGroup labelText="Forma de pagamento">
                                    <Select
                                        multiple={false}
                                        name="Forma de pagamento"
                                        placeholder="Buscar forma de pagamento"
                                        options={paymentMethodOptions}
                                        selected={contractRequest?.method || "BANK_SLIP"}
                                        onChange={(value) => handleChangeContract("method", value)}
                                    />
                                </FormGroup>
                                {contractRequest?.method === "CREDIT_CARD" &&
                                    <FormGroup labelText="Cartão de crédito">
                                        <Select
                                            multiple={false}
                                            name="Cartão de crédito"
                                            placeholder="Buscar cartão"
                                            options={creditCards}
                                            selected={contractRequest?.card_id || "ADD_NEW"}
                                            onChange={(value) => handleChangeContract("card_id", value)}
                                        />
                                    </FormGroup>
                                }
                                <FormGroup labelText="Cupom de desconto (opcional)">
                                    <div className={styles.couponControl}>
                                        <Input type="text" maxLength="40" placeholder="Digite o código" value={contractRequest?.coupon_code || ""} onChange={(event) => handleChangeContract("coupon_code", event.target.value.toUpperCase())} />
                                        <Button type="button" variant="secondary" fullWidth={false} disabled={!contractRequest?.coupon_code?.trim()} onClick={() => validateCoupon("contract")}>Aplicar</Button>
                                    </div>
                                </FormGroup>
                                {contractRequest?.coupon_preview?.eligible && <div className={styles.couponPreview}><span>Cupom aplicado</span><strong>- {formatCurrency(contractRequest.coupon_preview.pricing?.discount_amount)}</strong><small>Total estimado: {formatCurrency(contractRequest.coupon_preview.pricing?.net_amount)}</small></div>}
                                <div className={styles.contractPreview}>
                                    <div>
                                        <span>Plano atual</span>
                                        <strong>{isTrial ? "Advanced — teste grátis" : (account?.plan?.name || "-")}</strong>
                                    </div>
                                    <div>
                                        <span>{contractRequest?.type === "plan" ? "Novo plano" : (contractRequest?.type === "leads" ? "Custo por 1000 leads" : "Custo unitário")}</span>
                                        <strong>
                                            {contractRequest?.type === "plan"
                                                ? (selectedContractPlan?.name || "-")
                                                : `${formatCurrency(contractRequest?.type === "users" ? currentPlan?.additional_cost?.users : currentPlan?.additional_cost?.leads) || "-"}${contractRequest?.type === "leads" ? " / 1000" : ""}`}
                                        </strong>
                                    </div>
                                    <div>
                                        <span>{contractRequest?.type === "plan" ? "Valor mensal" : "Valor proporcional"}</span>
                                        <strong>{formatCurrency(contractEstimate) || "-"}</strong>
                                    </div>
                                </div>
                                {contractRequest?.type === "plan" &&
                                    <div className={styles.moduleCompare}>
                                        <span>Comparativo de módulos</span>
                                        <div className={styles.moduleChecklist}>
                                            {moduleDiff.allModules.length > 0 ? moduleDiff.allModules.map(module => (
                                                <div className={`${styles.moduleCheckItem} ${styles[module.status]}`} key={module.name}>
                                                    {module.status === "loss" ? <MdClose /> : <MdDone />}
                                                    <small>{module.name}</small>
                                                </div>
                                            )) : <div className={styles.moduleCheckItem}><MdDone /><small>Nenhum módulo listado</small></div>}
                                        </div>
                                    </div>
                                }
                                {contractRequest?.method === "BANK_SLIP" &&
                                    <div className={styles.contractNotice}>O boleto será aberto em uma nova aba e também exibirá QR code para pagamento via PIX.</div>
                                }
                                <FormGroupInline>
                                    <Button variant='primary' type="submit">{isTrial ? "Ir para pagamento" : "Gerar pagamento"}</Button>
                                    <Button variant='secondary' onClick={(e) => { e.preventDefault(); closeModalContract() }}>Cancelar</Button>
                                </FormGroupInline>
                            </form>
                        </Modal>
                    }
                    {modalRenewal &&
                        <Modal
                            icon={<TfiReload />}
                            title="Renovar assinatura"
                            description="Escolha como pagar a mensalidade da conta"
                            closeModal={closeModalRenewal}
                        >
                            <form onSubmit={handleSubmitRenewal} className={styles.contractForm}>
                                <div className={styles.renewalSummary}>
                                    <div>
                                        <span>Plano</span>
                                        <strong>{account?.plan?.name || "-"}</strong>
                                    </div>
                                    <div>
                                        <span>Mensalidade</span>
                                        <strong>{account?.plan?.value || "-"}</strong>
                                    </div>
                                    <div>
                                        <span>Status</span>
                                        <strong>{renewalStatusText}</strong>
                                    </div>
                                </div>
                                <FormGroup labelText="Forma de pagamento">
                                    <Select
                                        multiple={false}
                                        name="Forma de pagamento"
                                        placeholder="Buscar forma de pagamento"
                                        options={paymentMethodOptions}
                                        selected={renewalRequest?.method || "BANK_SLIP"}
                                        onChange={(value) => handleChangeRenewal("method", value)}
                                    />
                                </FormGroup>
                                {renewalRequest?.method === "CREDIT_CARD" &&
                                    <FormGroup labelText="Cartão de crédito">
                                        <Select
                                            multiple={false}
                                            name="Cartão de crédito"
                                            placeholder="Buscar cartão"
                                            options={creditCards}
                                            selected={renewalRequest?.card_id || "ADD_NEW"}
                                            onChange={(value) => handleChangeRenewal("card_id", value)}
                                        />
                                    </FormGroup>
                                }
                                <FormGroup labelText="Cupom de desconto (opcional)">
                                    <div className={styles.couponControl}>
                                        <Input type="text" maxLength="40" placeholder="Digite o código" value={renewalRequest?.coupon_code || ""} onChange={(event) => handleChangeRenewal("coupon_code", event.target.value.toUpperCase())} />
                                        <Button type="button" variant="secondary" fullWidth={false} disabled={!renewalRequest?.coupon_code?.trim()} onClick={() => validateCoupon("renewal")}>Aplicar</Button>
                                    </div>
                                </FormGroup>
                                {renewalRequest?.coupon_preview?.eligible && <div className={styles.couponPreview}><span>Cupom aplicado</span><strong>- {formatCurrency(renewalRequest.coupon_preview.pricing?.discount_amount)}</strong><small>Total estimado: {formatCurrency(renewalRequest.coupon_preview.pricing?.net_amount)}</small></div>}
                                <div className={styles.contractNotice}>
                                    {renewalRequest?.method === "BANK_SLIP"
                                        ? "Se já existir uma mensalidade em aberto com boleto válido, vamos abrir a cobrança atual. Se ela estiver vencida além da validade, uma nova mensalidade será emitida."
                                        : "Você pode pagar com um cartão salvo ou abrir um checkout para informar um novo cartão."}
                                </div>
                                <FormGroupInline>
                                    <Button variant='primary' type="submit">Pagar</Button>
                                    <Button variant='secondary' onClick={(e) => { e.preventDefault(); closeModalRenewal() }}>Cancelar</Button>
                                </FormGroupInline>
                            </form>
                        </Modal>
                    }
                </div>
            </div>
            {!account?.plan?.payment_by_partner && modalChangePlan &&
                <ModalConfirm
                    closeModal={handleCloseModalPlan}
                    onSubmit={handleUpdatePlan}
                    icon={<TfiReload />}
                    title={titleChangePlan}
                    description={descriptionChangePlan}
                    text={textChangePlan}
                />
            }
            {modalCreditCard &&
                <Suspense fallback={<Loading fullPage={true} />}>
                    <ModalCreditCard
                        onSuccess={handleAddCreditCardSuccess}
                        closeModal={() => setModalCreditCard(false)}
                    />
                </Suspense>
            }
            {cardToDelete &&
                <ModalConfirm
                    closeModal={() => setCardToDelete(null)}
                    onSubmit={handleDeleteCreditCard}
                    icon={<TbTrash />}
                    title="Excluir cartão"
                    description="Deseja remover este cartão?"
                    text={cardToDelete.value}
                />
            }
            {chargeDetails &&
                <Modal
                    icon={<TbReceiptTax />}
                    title="Detalhes da fatura"
                    description={`${getPropertyForItemInArrayById(chargeDetails?.transaction?.type, listTypes, "id", "value") || "Cobrança"} • ${chargeDetails?.charge?.value || "-"}`}
                    closeModal={closeChargeDetails}
                    fitContent={true}
                    heightFitContent={true}
                >
                    <div className={styles.chargeDetails}>
                        <section className={styles.detailSection}>
                            <div className={styles.detailSectionHeader}>
                                <span>Cobrança</span>
                                <strong>{getPropertyForItemInArrayById(chargeDetails?.charge?.status, listStatus, "id", "value") || "-"}</strong>
                            </div>
                            <div className={styles.detailGrid}>
                                {renderDetailItem("Valor bruto", chargeDetails?.transaction?.value)}
                                {renderDetailItem("Desconto", chargeDetails?.transaction?.discount)}
                                {renderDetailItem("Valor líquido", chargeDetails?.transaction?.net_value)}
                                {renderDetailItem("Vencimento", chargeDetails?.charge?.due_date)}
                                {renderDetailItem("Emissão", chargeDetails?.charge?.emit_date)}
                                {renderDetailItem("Pagamento", chargeDetails?.charge?.payday)}
                                {renderDetailItem("Tipo", getPropertyForItemInArrayById(chargeDetails?.transaction?.type, listTypes, "id", "value"))}
                                {renderDetailItem("Método", getPropertyForItemInArrayById(chargeDetails?.transaction?.method, listMethodsPayment, "id", "value"))}
                            </div>
                        </section>

                        <section className={styles.detailSection}>
                            <div className={styles.detailSectionHeader}>
                                <span>Pagamento</span>
                                <strong>{chargeDetails?.payment?.source === "SAVED_CARD" ? "Cartão salvo" : (chargeDetails?.payment?.source === "STRIPE_CHECKOUT" ? "Checkout Stripe" : (chargeDetails?.payment?.source === "BANK_SLIP" ? "Boleto / PIX" : "-"))}</strong>
                            </div>
                            <div className={styles.detailGrid}>
                                {renderDetailItem("Provedor", chargeDetails?.payment?.provider)}
                                {renderDetailItem("Cartão", chargeDetails?.payment?.card?.last4 ? `${chargeDetails?.payment?.card?.brand || "Cartão"} final ${chargeDetails.payment.card.last4}` : undefined)}
                                {renderDetailItem("Validade", chargeDetails?.payment?.card?.expMonth ? `${chargeDetails.payment.card.expMonth}/${chargeDetails.payment.card.expYear}` : undefined)}
                                {renderDetailItem("Payment Intent", chargeDetails?.payment?.payment_intent_id)}
                                {renderDetailItem("Sessão Stripe", chargeDetails?.payment?.session_id)}
                                {renderDetailItem("Pago em", chargeDetails?.payment?.charged_at)}
                                {renderDetailItem("Pago por", chargeDetails?.payment?.charged_by ? `${chargeDetails.payment.charged_by.name || "-"} (${chargeDetails.payment.charged_by.email || "-"})` : undefined)}
                                {renderDetailItem("País do cartão", chargeDetails?.payment?.card_extra?.country)}
                                {renderDetailItem("Tipo do cartão", chargeDetails?.payment?.card_extra?.funding)}
                            </div>
                        </section>

                        {(chargeDetails?.bank_slip?.digitable_line || chargeDetails?.bank_slip?.txid) &&
                            <section className={styles.detailSection}>
                                <div className={styles.detailSectionHeader}>
                                    <span>Boleto / PIX</span>
                                    <strong>Dados bancários</strong>
                                </div>
                                <div className={styles.detailGrid}>
                                    {renderDetailItem("Linha digitável", chargeDetails?.bank_slip?.digitable_line)}
                                    {renderDetailItem("Código de barras", chargeDetails?.bank_slip?.bar_code)}
                                    {renderDetailItem("TXID", chargeDetails?.bank_slip?.txid)}
                                    {renderDetailItem("Nosso número", chargeDetails?.bank_slip?.our_number)}
                                    {renderDetailItem("Seu número", chargeDetails?.bank_slip?.your_number)}
                                    {renderDetailItem("Cooperativa", chargeDetails?.bank_slip?.cooperative)}
                                    {renderDetailItem("Posto", chargeDetails?.bank_slip?.post)}
                                </div>
                            </section>
                        }

                        <section className={styles.detailSection}>
                            <div className={styles.detailSectionHeader}>
                                <span>Nota fiscal</span>
                                <strong>{chargeDetails?.invoice ? "Emitida" : "Não emitida"}</strong>
                            </div>
                            <div className={styles.detailGrid}>
                                {renderDetailItem("Número", chargeDetails?.invoice?.number)}
                                {renderDetailItem("Valor", chargeDetails?.invoice?.value)}
                                {renderDetailItem("Emissão", chargeDetails?.invoice?.created_at)}
                                {chargeDetails?.invoice?.link &&
                                    <a className={styles.detailLink} href={chargeDetails.invoice.link} target="_blank" rel="noreferrer">
                                        <TbExternalLink />Abrir nota fiscal
                                    </a>
                                }
                                {chargeDetails?.charge?.link_charge &&
                                    <a className={styles.detailLink} href={chargeDetails.charge.link_charge} target="_blank" rel="noreferrer">
                                        <TbExternalLink />Abrir pagamento
                                    </a>
                                }
                            </div>
                        </section>
                    </div>
                </Modal>
            }
            {loading && <Loading fullPage={true} />}
        </>
    )
}

export default MyAccount
